//old config

//export const PRODUCTION_API_URL = 'http://52.34.207.5:5128/';
// export const SOCKET_URL = 'http://52.34.207.5:5128';//cline live
// export const SOCKET_URL = 'http://178.62.51.251:5128'; //client prod
// export const SOCKET_URL = 'http://localhost:5128';//http://52.34.207.5:5128
// export const LOCAL_API_URL = 'http://localhost:5128/';
// export const VIDEO_CALL_URL = 'http://52.34.207.5:5127'
// export const PRODUCTION_URL = "http://52.34.207.5"; // Open comment when using staging
// export const PRODUCTION_PORT = 5127; // Open comment when using staging
// export const PRODUCTION_URL = "http://178.62.51.251"; // Open comment when using client prod
// export const PRODUCTION_PORT = 5127;
// export const CLIENT_LIVE_API_URL = 'http://46.101.72.113:5128/';
// export const CLIENT_PROD_API_URL = 'http://178.62.51.251:5128/';
// export const PAYMENT_SERVER_URL = 'http://localhost:5128';
// export const PRODUCTION_URL = "http://46.101.72.113"; // Open comment when using client live
// export const PRODUCTION_PORT = 5127; // Open comment when using client live


// // // sagar local
// export const PRODUCTION_API_URL = "http://52.34.207.5:5128/";
// export const PRODUCTION_API_URL = "http://172.10.28.60:5128/"; //local sagar
// // export const PRODUCTION_API_URL = "http://172.10.189.198:5128/"; //local kunal

// // export const SOCKET_URL = "http://52.34.207.5:5128";
// export const SOCKET_URL = "http://172.10.28.60:5128"; //local sagar
// // export const SOCKET_URL = "http://172.10.189.198:5128"; //local kunal

// // export const LOCAL_API_URL = "http://172.10.221.185:5128/";
// // export const LOCAL_API_URL = 'http://172.10.189.198:5128/'; //Kunal
// export const LOCAL_API_URL = 'http://172.10.28.60:5128/';   //sagar
// export const VIDEO_CALL_URL = "http://172.10.28.60:5128/";
// // export const VIDEO_CALL_URL = "http://172.10.189.198:5128/"; //kunal
// export const PRODUCTION_URL = "http://172.10.28.60";//sagar
// // export const PRODUCTION_URL = "http://52.34.207.5";
// export const PRODUCTION_PORT = 5127;
// export const CLIENT_LIVE_API_URL = "http://172.10.28.60:5128/";//sagar
// export const CLIENT_PROD_API_URL = "http://172.10.28.60:5128/";//sagar
// export const PAYMENT_SERVER_URL = "http://172.10.28.60:5128/";//sagar

// export const CLIENT_LIVE_API_URL = "http://172.10.189.198:5128/";//kunal
// export const CLIENT_PROD_API_URL = "http://172.10.189.198:5128/";//kunal
// export const PAYMENT_SERVER_URL = "http://172.10.189.198:5128/";//kunal



// // // // ridhi local
//  export const PRODUCTION_API_URL = "http://52.34.207.5:5128/";
// // export const PRODUCTION_API_URL = "http://172.10.28.60:5128/"; //local sagar
// // export const PRODUCTION_API_URL = "http://172.10.189.198:5128/"; //local kunal

// export const SOCKET_URL = "http://52.34.207.5:5128";
// // export const SOCKET_URL = "http://172.10.28.60:5128"; //local sagar
// // export const SOCKET_URL = "http://172.10.189.198:5128"; //local kunal

// export const LOCAL_API_URL = "http://172.10.28.60:5128/";
// // export const LOCAL_API_URL = 'http://172.10.189.198:5128/'; //Kunal
// // export const LOCAL_API_URL = 'http://172.10.28.60:5128/';   //sagar
// export const VIDEO_CALL_URL = "http://172.10.28.60:5128/";
// // export const VIDEO_CALL_URL = "http://172.10.189.198:5128/"; //kunal
// // export const PRODUCTION_URL = "http://172.10.28.60";//sagar
// export const PRODUCTION_URL = "http://52.34.207.5";
// export const PRODUCTION_PORT = 5127;
// // export const CLIENT_LIVE_API_URL = "http://172.10.28.60:5128/";//sagar
// // export const CLIENT_PROD_API_URL = "http://172.10.28.60:5128/";//sagar
// // export const PAYMENT_SERVER_URL = "http://172.10.28.60:5128/";//sagar

// // export const CLIENT_LIVE_API_URL = "http://172.10.189.198:5128/";//kunal
// // export const CLIENT_PROD_API_URL = "http://172.10.189.198:5128/";//kunal
// // export const PAYMENT_SERVER_URL = "http://172.10.189.198:5128/";//kunal

// local

// export const PRODUCTION_API_URL = "http://localhost:5128/"; //local sagar
// export const PRODUCTION_API_URL = "http://localhost:4576/"; //local sagar
// // export const CLIENT_TEST_LIVE_API_URL = "http://localhost:5128/";
// export const CLIENT_TEST_LIVE_API_URL = "http://localhost:4576/";

// // export const SOCKET_URL = "http://localhost:5128";
// export const SOCKET_URL = "http://localhost:4576";
// // export const SOCKET_URL = "http://172.10.221.185:5128"; //local sagar
// // export const LOCAL_API_URL = "http://localhost:5128/";
// export const LOCAL_API_URL = "http://localhost:4576/";
// // export const LOCAL_API_URL = 'http://172.10.189.198:5128/'; //Kunal
// // export const LOCAL_API_URL = 'http://172.10.221.185:5128/';   //sagar
// // export const VIDEO_CALL_URL = "http://localhost:5128/";
// export const VIDEO_CALL_URL = "http://localhost:4576/";
// // export const VIDEO_CALL_URL = "http://72.10.221.185:5128/"; //sagar
// export const PRODUCTION_URL = "http://localhost";
// // export const PRODUCTION_PORT = 5127;
// export const PRODUCTION_PORT = 4576;
// // export const CLIENT_LIVE_API_URL = "http://localhost:5128/";
// // export const CLIENT_PROD_API_URL = "http://localhost:5128/";
// // export const PAYMENT_SERVER_URL = "http://localhost:5128/";
// export const CLIENT_LIVE_API_URL = "http://localhost:4576/";
// export const CLIENT_PROD_API_URL = "http://localhost:4576/";
// export const PAYMENT_SERVER_URL = "http://localhost:4576/";






// staging
// export const PRODUCTION_API_URL = 'http://52.34.207.5:5128/';
// export const SOCKET_URL = 'http://52.34.207.5:5128';
// export const LOCAL_API_URL = 'http://52.34.207.5:5128/';
// export const VIDEO_CALL_URL = 'http://52.34.207.5:5127'
// export const PRODUCTION_URL = "http://52.34.207.5";
// export const PRODUCTION_PORT = 5127;
// export const CLIENT_LIVE_API_URL = 'https://52.34.207.5:5127';
// export const CLIENT_PROD_API_URL = 'http://178.62.51.251:5128/';
// export const PAYMENT_SERVER_URL = 'http://localhost:5128';
export function getURLForServer(environment){
    // environment =  'development'
    // environment =  'staging'
    environment =  'clientTest'
    if(environment === 'development') {
        // new staging
        return {

            PRODUCTION_API_URL : 'http://localhost:4576/',
            // CLIENT_TEST_LIVE_API_URL : 'https://test.medfixhealth.com/',
            CLIENT_TEST_LIVE_API_URL : 'http://localhost:4576/',
            SOCKET_URL : 'http://localhost:4576/',
            // SOCKET_URL : 'http://test.medfixhealth.com:4576/',
            LOCAL_API_URL : 'http://localhost:4576/',
            VIDEO_CALL_URL : 'http://localhost:4576',
            PRODUCTION_URL : "http://localhost",
            PRODUCTION_PORT : 5127,
            CLIENT_LIVE_API_URL : 'https://localhost:4576',
            CLIENT_PROD_API_URL : 'http://178.62.51.251:4576/',
            PAYMENT_SERVER_URL : 'http://localhost:4576',
        }
    
    }
    if (environment === 'staging') {
        return {

            PRODUCTION_API_URL : 'http://192.168.137.1:4576/',
            // CLIENT_TEST_LIVE_API_URL : 'http://192.168.137.1:4576/',
            CLIENT_TEST_LIVE_API_URL : 'http://192.168.137.1:4576/',
            SOCKET_URL : 'http://192.168.137.1:4576/',
            LOCAL_API_URL : 'http://192.168.137.1:4576/',
            VIDEO_CALL_URL : 'http://192.168.137.1:4576',
            PRODUCTION_URL : "http://192.168.137.1",
            PRODUCTION_PORT : 4576,
            // PRODUCTION_PORT : 5127,
            CLIENT_LIVE_API_URL : 'https://http://192.168.137.1:4576',
            CLIENT_PROD_API_URL : 'http://178.62.51.251:4576/',
            PAYMENT_SERVER_URL : 'http://192.168.137.1:4576',
        }
    }
    if (environment === 'clientTestLive') {
        return {

            PRODUCTION_API_URL : 'http://test.medfixhealth.com:4576/',
            // CLIENT_TEST_LIVE_API_URL : 'http://test.medfixhealth.com:4576/',
            CLIENT_TEST_LIVE_API_URL : 'http://test.medfixhealth.com:4576/',
            SOCKET_URL : 'http://test.medfixhealth.com:4576/',
            LOCAL_API_URL : 'http://test.medfixhealth.com:4576/',
            VIDEO_CALL_URL : 'http://test.medfixhealth.com:4576/',
            PRODUCTION_URL : "http://test.medfixhealth.com/",
            PRODUCTION_PORT : 4576,
            // PRODUCTION_PORT : 5127,
            CLIENT_LIVE_API_URL : 'http://test.medfixhealth.com:4576/',
            CLIENT_PROD_API_URL : 'http://test.medfixhealth.com:4576/',
            PAYMENT_SERVER_URL : 'http://test.medfixhealth.com:4576/',
        }
    }
    if (environment === 'clientTest') {
        return {

            PRODUCTION_API_URL : 'https://test.medfixhealth.com/',
            // CLIENT_TEST_LIVE_API_URL : 'https://test.medfixhealth.com/',
            CLIENT_TEST_LIVE_API_URL : 'https://test.medfixhealth.com/',
            SOCKET_URL : 'https://test.medfixhealth.com/',
            LOCAL_API_URL : 'https://test.medfixhealth.com/',
            VIDEO_CALL_URL : 'https://test.medfixhealth.com/',
            PRODUCTION_URL : "http://test.medfixhealth.com/",
            PRODUCTION_PORT : 4576,
            // PRODUCTION_PORT : 5127,
            CLIENT_LIVE_API_URL : 'https://test.medfixhealth.com/',
            CLIENT_PROD_API_URL : 'https://test.medfixhealth.com/',
            PAYMENT_SERVER_URL : 'https://test.medfixhealth.com/',
        }
    }
    
}



// //client live Production
// const PRODUCTION_API_URL = "https://www.medfixhealth.com/";
// export const CLIENT_LIVE_API_URL = "https://www.medfixhealth.com/";
// export const VIDEO_CALL_URL = "https://www.medfixhealth.com:5128/";
// export const SOCKET_URL = "https://www.medfixhealth.com/";
// export const PRODUCTION_URL = "https://www.medfixhealth.com";
// export const PRODUCTION_PORT = 5127;


//test live
// export const PRODUCTION_API_URL = "https://test.medfixhealth.com/";
// export const CLIENT_TEST_LIVE_API_URL = "https://test.medfixhealth.com/";
// export const VIDEO_CALL_URL = "https://test.medfixhealth.com:5128/";
// export const SOCKET_URL = "https://test.medfixhealth.com/";
// export const PRODUCTION_URL = "https://test.medfixhealth.com";
// export const PRODUCTION_PORT = 5127;